import mobx, { observable, action, computed } from 'mobx';
import api from '../../api';
import dict from '../dictStore';

export default class Results {

	@observable isLoading = 0;
	@observable sport = new Map();
	@observable league = new Map();
	@observable games = new Map();
	@observable noResultSport = [];
	@observable order = [];
	@observable dict = {};
	@observable cancel = {};
	store = null;

	constructor(store, data) {
		this.store = store;
	}

	@action loadResult(data) {
		this.store.clearError();
		if (data) {
			this.isLoading = 1;
			this.clear();
	  	api[`${this.store.mode}Results`].getResults(data).then(
				action( data => {

					if (Object.keys(data.result.league).length === 0) {
						return this.store.setError('NO_RESULTS', 1);
					}

					if (data.code == 0 && data.result) {
						if (data.result.games.length != 0) {
					  	if (data.result.cancel) this.cancel = data.result.cancel;
					  	this.dict = data.result.dict || {};
					  	this.addSport(data.result.sport);
					  	this.addLeague(data.result.league);
					  	this.addGames(data.result.games, data.result.ross, data.result.refund);
				  	} else {
				  		this.store.setError('NO_RESULTS', 1);
				  	}
					} else {
						this.store.setError(data.text ? data.text : 'SERVER_TEMPORARILY_DOWN');
					}
				}))
	      .catch(action(err => {
	        this.store.setError('SERVER_TEMPORARILY_DOWN');
	      }))
	      .finally(action(() => { this.isLoading = 0 }));
	  }
  }

  @action addSport(sport) {
		Object.values(sport).forEach(sid => {
			if (this.dict.sport) {
        sid.sport_name = this.dict.sport[sid.id];
      }
			this.sport.set(sid.id, sid);
		});
	}

  @action addLeague(league) {
		Object.values(league).forEach(lid => {
			if (this.dict.league) {
        lid.league_name = this.dict.league[lid.id];
      }
			lid.sid = lid.sport_id;
			delete lid.sport_id;
			this.league.set(lid.id, lid);
		});
	}

  @action addGames(games, ross, refund) {
		Object.values(games).forEach(gid => {
			if (this.dict.cmd) {
        gid.name = `${this.dict.cmd[gid.c1_id] ? this.dict.cmd[gid.c1_id] : ''} ${!this.dict.cmd[gid.c1_id] || !this.dict.cmd[gid.c2_id] ? '':'-' } ${this.dict.cmd[gid.c2_id]  ? this.dict.cmd[gid.c2_id] : ''}`;
      } else {
        gid.name = `${ gid.team_1_name ? gid.team_1_name : '' } ${
          !gid.team_1_name || !gid.team_2_name ? '' : '-'
        } ${ gid.team_2_name ? gid.team_2_name : '' }`;
      }

			if (ross && ross[gid.id]) {
				gid.dopBets = ross[gid.id];
			}
			if (refund && refund[gid.id]) {
				gid.refund = refund[gid.id];
			}
			gid.sid = gid.sport_id;
			delete gid.sport_id;

			this.games.set(gid.id, gid);
		});
	}

  @action clear() {
  	this.sport.clear();
  	this.league.clear();
  	this.games.clear();
  }

  printNoResults(other) {
      this.noResultSport = [];
      this.store.menu.selectedSports.forEach(item => {
      	if (!this.sport.has(item)){
      		this.noResultSport.push(this.store.menu.dict.sport[item]);
      	}

      	if (other.length !== 0 && item == 'other') {
          this.noResultSport.push(dict.getLang('OTHER'));
        }
      })
  }
}


// WEBPACK FOOTER //
// ./src/stores/resultStore/results.js